import net from '../../utils/net'
export default {
  // 获取公司地区列表
  GetDistrict (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取组织树列表
  gettreelist (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取组织类型列表
  DelOrgTypeDataList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取店铺数据列表
  getStoreDataList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 批量删除店铺数据
  DelStoreList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取企微模糊搜索数据
  getSearchName (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 添加店铺
  AddStore (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 编辑店铺
  editStore (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取店铺多语言
  getLang (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取所属品牌
  GetBrandInfo (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取店铺类型
  GetStoreType (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取默认货币
  GetEnableCurrency (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取经营方式
  GetManageType (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取经销商
  GetDealerInfo (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取组织详情
  getstoreDetail (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取公司店铺标签列表
  storeTagList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 创建店铺标签（不存在才创建）
  CreateStoreTag (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 批量保存店铺标签关联
  SaveRelationBatch (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取店铺关联标签
  MultiStoreTagRelation (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取店铺平面图列表
  blueprintlist (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 创建店铺平面图
  CreateBlueprint (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 删除店铺平面图
  delBlueprint (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 店铺头像截取
  uploadImg (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.getUpload(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 店铺管理下载模板Excal
  sysdomainDownExcal (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.getBlob(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 按模板导入数据
  importinfoImport (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 店铺管理导出Excal
  sysdomainExport (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.getBlob(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取店铺类型列表
  getStoreTypeList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 批量删除店铺类型
  deleteStoreType (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 添加店铺类型
  addStoreTypeAjax (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 编辑店铺类型
  editStoreTypeAjax (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取最新的序号
  SortNo (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取店铺类型详情
  getStoreTypeDetailAjax (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取品牌设定列表
  GetBrandList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 删除品牌数据
  DelBrandData (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取品牌数据详情
  GetBrandDetail (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 店铺导出转义
  ExportWXTranslateStore (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 重新同步
  AgainSync (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取区域树
  getAreaTree (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取地区列表
  getAreaList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 新增地区
  addAreaData (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 编辑地区信息
  updateAreaData (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 查询地区详情
  getAreaDataDetail (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 删除地区信息
  deleteAreaData (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  }
}
